'use client'

import { Text } from '@vinted/web-ui'
import { Suspense } from 'react'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

const AdInfo = () => {
  const translate = useTranslate('advertisements')

  return (
    <Suspense>
      <div className="slot-info" data-testid="slot-info" suppressHydrationWarning>
        <Text as="h4" type={Text.Type.Caption} theme="muted" text={translate('advertisement')} />
      </div>
    </Suspense>
  )
}

export default AdInfo
